export abstract class BaseColumn {
  _columnType: string;
  title: string;
  property: string;

  protected constructor(title: string,
                        config: BaseColumnConfig) {
    this._columnType = 'BaseColumn';
    this.title = title;
    this.property = config.property;
  }

  get(element: any): any {
    return element[this.property];
  }
}

export interface BaseColumnConfig {
  property: string;
}
